import { initVideoPlayers } from '@theme/lib-video-player';

/**
 * Initialize lib-video-player for all video block roots on the page.
 */
function initVideoBlocks() {
  document.querySelectorAll('.video-block').forEach((root) => {
    if (!(root instanceof HTMLElement)) return;
    initVideoPlayers(root);
  });
}

document.addEventListener('DOMContentLoaded', initVideoBlocks);
document.addEventListener('shopify:section:load', initVideoBlocks);
document.addEventListener('shopify:block:select', initVideoBlocks);
